import React from "react";
import { useNavigate } from "react-router-dom";

export default function ScholarshipListing() {
  const navigate = useNavigate();

  const handleAddScholarship = () => {
    navigate("/scholarship-listing/add-scholarship");
  };

  return (
    <div className="relative flex flex-col gap-2 h-[500px]">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold">Scholarship Listing</h2>
        <div className="flex gap-4">
          {/* <UploadExcel
            collectionName="university-listing"
            transformRow={transformRow}
            isDuplicate={isDuplicate}
            getDeduplicationKey={getDeduplicationKey}
            buttonLabel="Upload University"
          /> */}
          <button
            onClick={handleAddScholarship}
            className="w-32 bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
          >
            Add Scholarship
          </button>
        </div>
      </div>
    </div>
  );
}
